import { VPRPublication as Data } from '@/typings/api/VPRPublications'
import { Model, createMessages } from '@/helpers/Model'


export class VPRPublicationModel extends Model<Data> {
    public static readonly page_title = createMessages({
      create: 'Добавить публикацию',
      edit: 'Редактировать публикацию',
      view: (data: VPRPublicationModel) => 'Публикация «{name}»'
        .replace('{name}', data.name || '...'),
      list: 'Публикации ВПР',
    });

    public static readonly modal_delete = createMessages({
      delete: (data: VPRPublicationModel) => 'Удаление публикации «{name}»'
        .replace('{name}', data.name || '...'),
      delete_all: 'Удаление выбранных публикаций',
      delete_all_partly: 'Удаление части выбранных публикаций',
      archive_all: 'Архивирование выбранных публикаций',
    });

    public static readonly response_success = createMessages({
      ...Model.response_success,
    });

    public static readonly response_error = createMessages({
      ...Model.response_error,
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static getId<D = any>(data: D | any): string | number {
      return data.vpr_publication_id
    }
}
